import React from 'react'

// Avance School of Real Estate identification, as ADRE requires it to appear
// wherever CE is offered. Self-contained on purpose: inline styles only, no
// class names, no scoped <style> block, no imported constants. It is dropped
// into public pages that each own a different styling system — RecruitLanding
// scopes everything under .rec-root, DemoLanding under .dm-, FeedbackSurvey
// under .fb- — so anything it inherited from a parent would render differently
// on each page. Nothing here depends on where it is mounted.
//
// The five lines are fixed text. Do not add a school address, course numbers,
// or an hour count.
//
// `variant` selects the palette and nothing else — every other value below is
// fixed across both. 'light' is the default and is exactly what /demo has
// always rendered, so an unprefixed <SchoolDisclosure /> is unchanged. 'dark'
// exists for /join, whose footer sits on --ink (#08080A) where #666 body text
// on a near-black ground is close to unreadable. Font is deliberately still
// inherited in both: this drops into pages using different families and should
// look native to each.
//
// `align` selects centring and nothing else. 'center' is the default and is
// what all three footer call sites render — the block is its own centred row
// there. 'left' exists for the landing page's Section 04, where it sits inside
// a left-aligned column under the CE button and would read as a stray centred
// island against the copy above it. Only textAlign and margin change; the
// 430px cap holds either way, so the measure stays the same.
const TONES = {
  light: { body: '#666',    head: '#1d2e42' },
  dark:  { body: '#9A9AA4', head: '#FFFFFF' },
}

const ALIGNS = {
  center: { textAlign: 'center', margin: '0 auto' },
  left:   { textAlign: 'left',   margin: '0' },
}

export default function SchoolDisclosure({ variant = 'light', align = 'center' }) {
  // Both fall back rather than rendering colorless or unpositioned text, since
  // this block is a compliance requirement and must stay legible wherever it
  // lands.
  const tone = TONES[variant] || TONES.light
  const pos = ALIGNS[align] || ALIGNS.center
  return (
    <div style={{
      fontSize: '11px',
      color: tone.body,
      lineHeight: 1.75,
      textAlign: pos.textAlign,
      maxWidth: '430px',
      margin: pos.margin,
    }}>
      <span style={{ color: tone.head }}>Avance School of Real Estate</span><br />
      Avance School of Real Estate LLC<br />
      ADRE School #S22-0004<br />
      Josh Marquez, School Director &middot; 480-942-2595<br />
      info@avanceschool.com
    </div>
  )
}
